module.exports = __webpack_public_path__ + "static/colgadas-007-7d9e36e36c8c0a5b1b807678251f57d1.jpg";